import React, {useState} from 'react';
import Timer from './Timer.js';

const FormTime = React.forwardRef(({readOnly = false, label, value, setValue, error, placeholder = '', maxLength, iconPosTop = '50%'}, ref) => {
	const [showTimer, setShowTimer] = useState(false);

	if (placeholder === '') {
		placeholder = label;
	}

	if (!maxLength) {
		maxLength = 100;
	}

	const showMeta = label !== '' || error !== '';
	const iconStyle = iconPosTop === '50%' ? {top: '50%', transform: 'translateY(-50%)'} : {top: iconPosTop};

	const showTimerFunc = () => {
		setShowTimer(true);
	};

	const closeTimer = () => {
		setShowTimer(false);
	};

	const returnValue = (val) => {
		setValue(val);
	};

	const iconClick = () => {
		if (readOnly) {
			showTimerFunc();
		}
	};

	return (
		<>
			<div className={`input-div input-div--with-icon${error !== '' ? ' has-error' : ''}`}>
				{showMeta ? (
					<div className="input-meta">
						<div className="input-meta-left">
							{label !== '' ? <div className="input-label">{label}</div> : ''}
						</div>
						{error !== '' ? <div className="input-error">{error}</div> : ''}
					</div>
				) : ''}
				<div className="input-control input-control--with-icon">
					<input className={`input-text ${readOnly ? 'cr_p' : ''}`} type="text" maxLength={maxLength} readOnly={readOnly} placeholder={placeholder} ref={ref} value={value} onChange={(e) => setValue(e.target.value)} onClick={() => iconClick()} />
					<span className="input-text-time-cal-icon" style={iconStyle} onClick={() => showTimerFunc()}></span>
				</div>
			</div>

			<Timer show={showTimer} close={closeTimer} defaultValue={value} returnValue={returnValue} />
		</>
	);
});

export default FormTime;
